import { motion } from "framer-motion";

const CHAPTERS = [
  {
    number: "01",
    title: "Passive watching is dead.",
    text: "Feeds became solitary isolation chambers. IN-It turns scrolling into shared presence — the audience doesn't just watch the moment, they step inside it.",
  },
  {
    number: "02",
    title: "Every moment is a portal.",
    text: "When something's happening around you, open an IN. One tap and the people you want are standing next to you — from Gothenburg to anywhere.",
  },
  {
    number: "03",
    title: "Safe by design.",
    text: "Every report lands directly with a human on our team at report@in-itapp.com. No black holes, no bots — swift, accountable answers.",
  },
];

export const ManifestoChapters = () => {
  return (
    <section id="manifesto" className="relative py-28 sm:py-36 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-mono text-xs uppercase tracking-[0.3em] text-ink-coral mb-16"
        >
          THE IN-IT CODE
        </motion.p>

        <div className="space-y-20">
          {CHAPTERS.map((ch, i) => (
            <motion.div
              key={ch.number}
              data-testid={`manifesto-chapter-${i + 1}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className="grid md:grid-cols-12 gap-6 items-baseline border-t border-white/10 pt-10"
            >
              <span className="md:col-span-3 font-display font-extrabold text-7xl sm:text-8xl text-outline leading-none select-none">
                {ch.number}
              </span>
              <h3 className="md:col-span-4 font-display font-bold text-white text-2xl sm:text-3xl tracking-tight">
                {ch.title}
              </h3>
              <p className="md:col-span-5 text-zinc-400 leading-relaxed text-base">
                {ch.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
